import React, { useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import history from "utils/history";

// styles
import "./style.scss";

// antd component
import { List, Empty, Tooltip } from "antd";

// assets
import CustomIcons from "components/CustomIcons";

// global user
import { useGetUserChildren } from "engine/Contexts/User.context";

// utils
import { getObjId, sortByKey } from "utils/helpers/helper.general";
import { getAttendancesOnDate } from "utils/helpers/helper.generateData";
import _local from "utils/localStorageUtils";
import { convertTimeToString } from "utils/moment/moment.utils";

function CoursesList({
  dataSourse,
  selectedDate,
  timeZone,
  showAll,
  appointments,
  // states
  loading,
  // default props
  className,
  style,
}) {
  const mainClassNames = classNames("courses-mobile-wrapper", className);
  const { t } = useTranslation();

  const localUser = _local.getLocalUser();
  const localActiveChild = _local.getLocalChild();
  const children = useGetUserChildren()();

  const userStudents = localUser?.role == "parent" ? children : [];

  // NOTE! - Commented because of SCHOOL-847 - mobile ios issue
  // const getMaxHeight = () => {
  //   //45 - header height
  //   //60 - from .main-content-container (max-height css function)
  //   //57 - .courses-list-wrapper__switch height
  //   //241 - calendar height (from design. Update if actual height will be different)
  //   return window.innerHeight - 45 - 60 - 57 - 15 - 241;
  // };

  const getCoursesStudents = useCallback(
    courseStudents => {
      if (
        !(
          userStudents &&
          Array.isArray(userStudents) &&
          userStudents.length > 0
        )
      )
        return [];

      const studentsNames = userStudents
        ?.map(std =>
          courseStudents.find(el => getObjId(el) == getObjId(std))
            ? {
                _id: getObjId(std),
                name: std?.description?.firstname,
              }
            : null,
        )
        .filter(el => el !== null);
      return studentsNames;
    },
    [userStudents],
  );

  const clickHandle = useCallback(
    itemID => {
      localUser?.role !== "parent" &&
        history.push({
          pathname: `/сours/${itemID}`,
          search: "",
          hash: "",
          state: {
            onDate: selectedDate || false,
            timeZone: timeZone || false,
            goBack: "/сours",
            goBackTitle: t("labels.course"),
          },
        });
    },
    [localUser?.role, selectedDate, history],
  );

  const showStdsNames = useCallback(
    tdsNames => {
      return (
        showAll &&
        localUser?.role == "parent" &&
        tdsNames?.length > 0 && (
          <span className="list-items-meta-student">
            {tdsNames?.map((element, nx) => {
              const sep = tdsNames.length - 1 != nx ? ", " : "";
              return (
                <>
                  <span
                    className={`name ${
                      getObjId(element) == getObjId(localActiveChild)
                        ? "active"
                        : ""
                    }`}
                  >
                    {element?.name}
                  </span>
                  {sep}
                </>
              );
            })}
          </span>
        )
      );
    },
    [localUser?.role, showAll, localActiveChild],
  );

  const courseItem = useCallback(
    item => {
      const studentsNames =
        !!item?.students && getCoursesStudents(item?.students);
      const courseClasses =
        item?.classes?.length > 0 &&
        item?.classes?.map(classInfo => classInfo?.title)?.join(", ");
      return (
        <List.Item
          key={item?._id + "-course-list"}
          className="list-items"
          onClick={() => !item?.appointmentDate && clickHandle(item?._id)}
        >
          <List.Item.Meta
            title=""
            className="list-items-meta"
            description={
              <>
                {item?.course_time_start && (
                  <span className="list-items-meta-start-time">
                    {convertTimeToString(item?.course_time_start)}
                  </span>
                )}

                <div className="list-item-meta-wrapper">
                  <div className="list-item-meta-subject-wrapper">
                    <span className="list-items-meta-subject-name">
                      {item?.subject?.name}
                    </span>

                    {!!item?.students && showStdsNames(studentsNames)}
  
                    <div className="list-items-meta-wrapper-marks">
                      {!!item?.hasAtt && (
                        <Tooltip
                          placement="top"
                          trigger="hover"
                          color="#28a745"
                          title={t("attendances.controlScreenTitle")}
                          className="mark-tooltip"
                          getPopupContainer={trigger => trigger.parentElement}
                        >
                          <span className="list-items-meta-mark attendance-mark">
                            <CustomIcons type="registred" />
                          </span>
                        </Tooltip>
                      )}
                      {!!courseClasses && localUser?.role == "teacher" && (
                        <span className="list-items-meta-teacher">
                          {courseClasses}
                        </span>
                      )}
                      {!item?.appointmentDate && (
                        <span className="list-items-meta-class-room">
                          {item?.class_room ? item?.class_room : "--"}
                        </span>
                      )}
                      {!!item?.appointmentDate && (
                        <span className="list-items-meta-mark appointment-mark">
                          <CustomIcons type="calendar" />
                        </span>
                      )}
                    </div>
                  </div>

                  {/*

              --- For Future sprints

              {item?.homework &&
              item?.lesson &&
              activeSubject &&
              activeSubjectId === item?._id && (
                <div className="list-items-meta-wrapper-extra-data">
                  <div className="extra-data-homework">
                    <span className="extra-data-homework-title">
                      Devoirs
                    </span>

                    <span className="extra-data-homework-item">
                      {item?.homework}
                    </span>
                  </div>
                  <div className="extra-data-lesson">
                    <span className="extra-data-lesson-title">
                      Leçons
                    </span>

                    <span className="extra-data-lesson-item">
                      {item?.lesson}
                    </span>
                  </div>
                </div>
              )} */}
                </div>
              </>
            }
          />
        </List.Item>
      );
    },
    [history, localUser],
  );

  let dataSourseNew =
    (dataSourse &&
      dataSourse.map(el => {
        const currentAttendanceArr = getAttendancesOnDate(el, selectedDate);
        const att = currentAttendanceArr?.[0];
        return {
          ...el,
          title: `<span className="time">${convertTimeToString(el?.course_time_start)}</span> <span className="cours-name">${el?.subject?.name}</span>`,
          hasAtt: getObjId(att?.course) == getObjId(el),
        };
      })) ||
    [];

  // Add appointments to the list and adapt it
  if (!!appointments && Array.isArray(appointments)) {
    dataSourseNew = [...dataSourseNew, ...appointments];
  }

  dataSourseNew = dataSourseNew
    ?.map(el => {
      if (!!el?.course_time_start) {
        return el;
      }
      if (!!el?.adminAnswer) {
        return {
          ...el,
          course_time_start: el?.adminAnswer?.slot?.timeFrom,
          subject: {
            name: el?.title,
          },
          students: [el?.student],
          title: `<span className="time">${convertTimeToString(el?.adminAnswer?.slot?.timeFrom)}</span> <span className="cours-name">${
            el?.title
          }</span>`,
        };
      } else {
        return el;
      }
    })
    .sort(sortByKey("title"));

  return (
    <div className={mainClassNames} style={style}>
      <List
        header=""
        className="courses-mobile-wrapper__list"
        dataSource={dataSourseNew}
        renderItem={courseItem}
        loading={loading}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={t("errors.noData")}
            />
          ),
        }}
      />
    </div>
  );
}

CoursesList.defaultProps = {
  showAll: false,
  loading: false,
};
CoursesList.propTypes = {
  dataSourse: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.array.isRequired,
  ]),
  loading: PropTypes.bool,
  showAll: PropTypes.bool,
};

export default CoursesList;
